<template>
  <v-container fluid>
    <div v-if="isLoading" class="d-flex justify-center my-3">
      <v-progress-circular
        color="primary"
        indeterminate
        size="64"
      ></v-progress-circular>
    </div>

    <div class="d-flex flex-column justify-center align-center">

      <div class="col-12 col-lg-6">
        <v-card tile flat>
          <v-card-text class="d-flex flex-column justify-center align-center text-center">
            <h2>{{$t('cards.titles.activateConfirmHeader')}}</h2>
            <div v-html="$t('cards.texts.activationConfirm')"></div>
          </v-card-text>
        </v-card>
      </div>
    </div>
    
    <div class="d-flex flex-column justify-center align-center">
      
      <div class="col-12 col-lg-6">
        <v-card tile flat>
          <v-card-title class="d-flex justify-center align-center text-center text-break">
            {{ $t('cards.titles.activateConfirm') }}
          </v-card-title>
          <v-card-text>

            <v-otp-input
                length="5"
                v-model="otp"
                :disabled="otpLoading"
                @finish="onFinish"
            ></v-otp-input>
            
          </v-card-text>
        </v-card>
        <v-alert
            v-if="wrongCode"
            class="mt-3"
            text
            tile
            type="error"
        >
       <div v-html="$t('card.texts.activationError')"></div>
        </v-alert>
        

      </div>
      
    </div>


    
  </v-container>
</template>

<script>
import i18n from "@/services/i18n";
import maxios from "@/services/mediligo-axios";
export default {
  i18n: i18n,
  name: "m2h-activate-confirm",
  props: ['session-id', 'start-page'],
  components: {},
  data() {
    return {
      isLoading: false,
      otpLoading: false,
      otp: '',
      text: '',
      wrongCode: false,
      snackbarColor: 'success'
    }
  },
  mounted() {
  },

  methods: {
    async onFinish(rsp) {
      this.otpLoading = true

      const res = await maxios.post("/api/onboarding/activationConfirm", {code: rsp, session: this.sessionId})
      if (!res.data.success) {
        if (res.data.reason === 'wrong_code') {
          this.otpLoading = false
          this.wrongCode = true;
          this.erroredEmail = [this.$t('forms.alreadyActivated')]
        }
      } else {
        window.location.href = '/password/' + this.sessionId;
      }
    },
  }
}
</script>

<style scoped>

</style>
